// Browser storage used by the Saf3AI Agent chat panel. No imports on purpose:
// authService calls clearChatStorage() on logout and must not pull in the
// API client.

// Legacy browser-only keys: `${LEGACY_CHAT_HISTORY_KEY}_analyst|helper` held
// the whole transcript and were shared by every user of the browser. History
// now lives in the AI microservice (chatHistoryStore.js).
export const LEGACY_CHAT_HISTORY_KEY = 'saf3ai_chat_history';
// Analyst/Helper toggle. Stored per user (`${AGENT_MODE_KEY}_<userId>`); the
// bare key is the old shared one.
export const AGENT_MODE_KEY = 'saf3ai_agent_mode';
export const AGENT_MODES = ['analyst', 'helper'];

const safeStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const currentUserId = (storage = safeStorage()) => {
  try {
    const user = JSON.parse(storage?.getItem('user') || 'null');
    return user?.user_id ?? user?.id ?? null;
  } catch {
    return null;
  }
};

const agentModeKey = (storage) => `${AGENT_MODE_KEY}_${currentUserId(storage) ?? 'anonymous'}`;

export const readAgentMode = (storage = safeStorage()) => {
  try {
    const mode = storage?.getItem(agentModeKey(storage));
    return AGENT_MODES.includes(mode) ? mode : 'analyst';
  } catch {
    return 'analyst';
  }
};

export const writeAgentMode = (mode, storage = safeStorage()) => {
  try {
    storage?.setItem(agentModeKey(storage), mode);
  } catch {
    // ignore quota / privacy-mode errors
  }
};

// Drop the pre-backend transcripts (and the old shared mode key). They are not
// migrated: nothing records whose they were, and uploading a previous user's
// chat into the current user's account would be the very leak this replaces.
export const clearLegacyChatHistory = (storage = safeStorage()) => {
  try {
    storage?.removeItem(LEGACY_CHAT_HISTORY_KEY);
    AGENT_MODES.forEach((mode) => storage?.removeItem(`${LEGACY_CHAT_HISTORY_KEY}_${mode}`));
    storage?.removeItem(AGENT_MODE_KEY);
  } catch {
    // ignore
  }
};

// Logout: no transcript may outlive the session on a shared browser. The
// per-user Analyst/Helper preference is not sensitive and is kept.
export const clearChatStorage = (storage = safeStorage()) => {
  try {
    const keys = [];
    for (let i = 0; i < (storage?.length || 0); i += 1) keys.push(storage.key(i));
    keys
      .filter((key) => key && key.startsWith(LEGACY_CHAT_HISTORY_KEY))
      .forEach((key) => storage.removeItem(key));
    storage?.removeItem(AGENT_MODE_KEY);
  } catch {
    // ignore
  }
};
